import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { Notification } from 'utils/types';
import { AxiosError } from 'axios';

import c from '../utils/constants';

export default function useGetAdminNotifications(
  params: Record<string, any> | null,
) {
  const { state } = useProvider();
  const args = state;

  return useQuery<Notification[], AxiosError>({
    queryKey: [c.ADMIN_NOTIFICATIONS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get({
        url: `api/v3/notifications`,
        params,
      });

      return data?.data;
    },
    retry: 1,
  });
}
